// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/corporate-theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App Global Styles - Corporate Theme */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  height: 100%;
  overflow-x: hidden;
}

body {
  font-family: var(--font-family-base);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--gray-50);
  color: var(--gray-700);
  line-height: var(--line-height-normal);
  height: 100%;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

.App {
  min-height: 100vh;
  height: 100%;
}

.app-loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-light) 100%);
  color: var(--white);
}

.app-loading .loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid var(--white);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: var(--space-lg);
}

.app-loading p {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-medium);
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* Global Button Styles */
button {
  cursor: pointer;
  transition: all var(--transition-fast);
  font-family: var(--font-family-base);
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

/* Global Input Styles */
input, textarea, select {
  font-family: var(--font-family-base);
}

input:focus, textarea:focus, select:focus {
  outline: none;
}

/* Utility Classes */
.text-center {
  text-align: center;
}

.text-left {
  text-align: left;
}

.text-right {
  text-align: right;
}

.mt-sm { margin-top: var(--space-sm); }
.mt-md { margin-top: var(--space-md); }
.mt-lg { margin-top: var(--space-lg); }
.mt-xl { margin-top: var(--space-xl); }

.mb-sm { margin-bottom: var(--space-sm); }
.mb-md { margin-bottom: var(--space-md); }
.mb-lg { margin-bottom: var(--space-lg); }
.mb-xl { margin-bottom: var(--space-xl); }

.p-sm { padding: var(--space-sm); }
.p-md { padding: var(--space-md); }
.p-lg { padding: var(--space-lg); }
.p-xl { padding: var(--space-xl); }

.text-right {
  text-align: right;
}

.mt-1 { margin-top: 0.25rem; }
.mt-2 { margin-top: 0.5rem; }
.mt-3 { margin-top: 0.75rem; }
.mt-4 { margin-top: 1rem; }
.mt-5 { margin-top: 1.25rem; }

.mb-1 { margin-bottom: 0.25rem; }
.mb-2 { margin-bottom: 0.5rem; }
.mb-3 { margin-bottom: 0.75rem; }
.mb-4 { margin-bottom: 1rem; }
.mb-5 { margin-bottom: 1.25rem; }

.p-1 { padding: 0.25rem; }
.p-2 { padding: 0.5rem; }
.p-3 { padding: 0.75rem; }
.p-4 { padding: 1rem; }
.p-5 { padding: 1.25rem; }

/* Color Classes */
.text-primary { color: #075E54; }
.text-success { color: #25D366; }
.text-warning { color: #ffc107; }
.text-danger { color: #dc3545; }
.text-muted { color: #666; }

.bg-primary { background-color: #075E54; }
.bg-success { background-color: #25D366; }
.bg-warning { background-color: #ffc107; }
.bg-danger { background-color: #dc3545; }
.bg-light { background-color: #f8f9fa; }

/* Responsive Utilities */
.d-none { display: none; }
.d-block { display: block; }
.d-flex { display: flex; }
.d-inline { display: inline; }
.d-inline-block { display: inline-block; }

@media (max-width: 768px) {
  .d-md-none { display: none; }
  .d-md-block { display: block; }
}

@media (max-width: 640px) {
  .d-sm-none { display: none; }
  .d-sm-block { display: block; }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAGxC;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,kCAAkC;EAClC,0BAA0B;EAC1B,sBAAsB;EACtB,sCAAsC;EACtC,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,uFAAuF;EACvF,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kCAAkC;EAClC,kBAAkB;EAClB,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,SAAS,2BAA2B,EAAE;AACtC,SAAS,2BAA2B,EAAE;AACtC,SAAS,2BAA2B,EAAE;AACtC,SAAS,2BAA2B,EAAE;;AAEtC,SAAS,8BAA8B,EAAE;AACzC,SAAS,8BAA8B,EAAE;AACzC,SAAS,8BAA8B,EAAE;AACzC,SAAS,8BAA8B,EAAE;;AAEzC,QAAQ,wBAAwB,EAAE;AAClC,QAAQ,wBAAwB,EAAE;AAClC,QAAQ,wBAAwB,EAAE;AAClC,QAAQ,wBAAwB,EAAE;;AAElC;EACE,iBAAiB;AACnB;;AAEA,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,gBAAgB,EAAE;AAC1B,QAAQ,mBAAmB,EAAE;;AAE7B,QAAQ,sBAAsB,EAAE;AAChC,QAAQ,qBAAqB,EAAE;AAC/B,QAAQ,sBAAsB,EAAE;AAChC,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,sBAAsB,EAAE;;AAEhC,OAAO,gBAAgB,EAAE;AACzB,OAAO,eAAe,EAAE;AACxB,OAAO,gBAAgB,EAAE;AACzB,OAAO,aAAa,EAAE;AACtB,OAAO,gBAAgB,EAAE;;AAEzB,kBAAkB;AAClB,gBAAgB,cAAc,EAAE;AAChC,gBAAgB,cAAc,EAAE;AAChC,gBAAgB,cAAc,EAAE;AAChC,eAAe,cAAc,EAAE;AAC/B,cAAc,WAAW,EAAE;;AAE3B,cAAc,yBAAyB,EAAE;AACzC,cAAc,yBAAyB,EAAE;AACzC,cAAc,yBAAyB,EAAE;AACzC,aAAa,yBAAyB,EAAE;AACxC,YAAY,yBAAyB,EAAE;;AAEvC,yBAAyB;AACzB,UAAU,aAAa,EAAE;AACzB,WAAW,cAAc,EAAE;AAC3B,UAAU,aAAa,EAAE;AACzB,YAAY,eAAe,EAAE;AAC7B,kBAAkB,qBAAqB,EAAE;;AAEzC;EACE,aAAa,aAAa,EAAE;EAC5B,cAAc,cAAc,EAAE;AAChC;;AAEA;EACE,aAAa,aAAa,EAAE;EAC5B,cAAc,cAAc,EAAE;AAChC","sourcesContent":["/* App Global Styles - Corporate Theme */\n@import './styles/corporate-theme.css';\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  height: 100%;\n  overflow-x: hidden;\n}\n\nbody {\n  font-family: var(--font-family-base);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: var(--gray-50);\n  color: var(--gray-700);\n  line-height: var(--line-height-normal);\n  height: 100%;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;\n}\n\n.App {\n  min-height: 100vh;\n  height: 100%;\n}\n\n.app-loading {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-light) 100%);\n  color: var(--white);\n}\n\n.app-loading .loading-spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid rgba(255, 255, 255, 0.3);\n  border-top: 4px solid var(--white);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: var(--space-lg);\n}\n\n.app-loading p {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-medium);\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n/* Global Button Styles */\nbutton {\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  font-family: var(--font-family-base);\n}\n\nbutton:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n/* Global Input Styles */\ninput, textarea, select {\n  font-family: var(--font-family-base);\n}\n\ninput:focus, textarea:focus, select:focus {\n  outline: none;\n}\n\n/* Utility Classes */\n.text-center {\n  text-align: center;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.mt-sm { margin-top: var(--space-sm); }\n.mt-md { margin-top: var(--space-md); }\n.mt-lg { margin-top: var(--space-lg); }\n.mt-xl { margin-top: var(--space-xl); }\n\n.mb-sm { margin-bottom: var(--space-sm); }\n.mb-md { margin-bottom: var(--space-md); }\n.mb-lg { margin-bottom: var(--space-lg); }\n.mb-xl { margin-bottom: var(--space-xl); }\n\n.p-sm { padding: var(--space-sm); }\n.p-md { padding: var(--space-md); }\n.p-lg { padding: var(--space-lg); }\n.p-xl { padding: var(--space-xl); }\n\n.text-right {\n  text-align: right;\n}\n\n.mt-1 { margin-top: 0.25rem; }\n.mt-2 { margin-top: 0.5rem; }\n.mt-3 { margin-top: 0.75rem; }\n.mt-4 { margin-top: 1rem; }\n.mt-5 { margin-top: 1.25rem; }\n\n.mb-1 { margin-bottom: 0.25rem; }\n.mb-2 { margin-bottom: 0.5rem; }\n.mb-3 { margin-bottom: 0.75rem; }\n.mb-4 { margin-bottom: 1rem; }\n.mb-5 { margin-bottom: 1.25rem; }\n\n.p-1 { padding: 0.25rem; }\n.p-2 { padding: 0.5rem; }\n.p-3 { padding: 0.75rem; }\n.p-4 { padding: 1rem; }\n.p-5 { padding: 1.25rem; }\n\n/* Color Classes */\n.text-primary { color: #075E54; }\n.text-success { color: #25D366; }\n.text-warning { color: #ffc107; }\n.text-danger { color: #dc3545; }\n.text-muted { color: #666; }\n\n.bg-primary { background-color: #075E54; }\n.bg-success { background-color: #25D366; }\n.bg-warning { background-color: #ffc107; }\n.bg-danger { background-color: #dc3545; }\n.bg-light { background-color: #f8f9fa; }\n\n/* Responsive Utilities */\n.d-none { display: none; }\n.d-block { display: block; }\n.d-flex { display: flex; }\n.d-inline { display: inline; }\n.d-inline-block { display: inline-block; }\n\n@media (max-width: 768px) {\n  .d-md-none { display: none; }\n  .d-md-block { display: block; }\n}\n\n@media (max-width: 640px) {\n  .d-sm-none { display: none; }\n  .d-sm-block { display: block; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
